export { default, getStaticProps } from "app/maintenance/page";
